import './customerGlobal.css';

export const CustomerGlobal = () => null;
